module.exports = __webpack_public_path__ + "img/image 002.4e723838.png";